var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"button",attrs:{"data-theme":_vm.theme,"to":_vm.to || {}}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }